import { render, staticRenderFns } from "./exportIcon.vue?vue&type=template&id=6e47dcf8&scoped=true&v-once=true"
import script from "./exportIcon.vue?vue&type=script&lang=js"
export * from "./exportIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47dcf8",
  null
  
)

export default component.exports